import { includes } from 'lodash/fp';

export const EXPLAINED_TERMS_SLUG_BLOCKLIST = {
  EXTRAS_COVER_LANDING_PAGE: 'extras-cover-ccs',
  HEALTH_INSURANCE_LANDING_PAGE: 'health-insurance-ccs',
};

const isInExplainedBlocklist = (slug: string | undefined) => includes(slug, EXPLAINED_TERMS_SLUG_BLOCKLIST);

export default isInExplainedBlocklist;
